<div class="container">
  @if (!isLoading) {
    @if (formType() === 'read-only') {
      <div class="center read-only">
        <form [formGroup]="noteFormGroup">
          <div formGroupName="typeAOR">
            <div class="card-header">
              <h3>{{ 'CRM.LABEL.NOTE_TYPE_AOR' | translate }}</h3>
              @if (!isEditing) {
                <app-actions-dropdown
                  class="dropdown right-align"
                  [availableActions]="availableActions"
                  (actionSelected)="onActionSelected($event)"
                  #actions
                />
              }
            </div>
            <div class="note-type-aor">
              <div class="row type-aor-row">
                <div id="category" class="row-item">
                  <label for="category"
                    >{{ 'CRM.LABEL.CATEGORY' | translate }}:
                    <span class="required">*</span>
                  </label>
                  {{ controllerNote()?.category }}
                </div>
                <div class="note-type" class="row-item">
                  <label for="noteType"
                    >{{ 'CRM.LABEL.NOTE_TYPE' | translate }}:
                    <span class="required">*</span></label
                  >
                  {{ controllerNote()?.noteType }}
                </div>
                <div id="createdAt" class="text-center" class="row-item">
                  <label class="date-label" for="createdAt"
                    >{{ 'COMMON.LABEL.CREATED_AT' | translate }}:
                    <span class="required">*</span>
                  </label>
                  {{
                    $safeNavigationMigration(controllerNote()?.createdAt)
                      | date: 'MM/dd/yyyy HH:mm:ss'
                  }}
                </div>
                <div id="aor" class="row-item">
                  <label for="aor"
                    >{{ 'CRM.LABEL.AOR' | translate }}:
                    <span class="required">*</span>
                  </label>
                  {{ controllerNote()?.AORName }}
                </div>
              </div>
              <div class="break"></div>
              <div class="checkbox-row">
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="maop"
                    value="MAOP"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.MAOP' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="falseAlarm"
                    value="False Alarm"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.FALSE_ALARM' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="abnormalOperation"
                    value="Abnormal Operation"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.ABNORMAL_OP' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="includeInTurnover"
                    value="Include in Turnover"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.INC_IN_TURNOVER' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="calloutInitiated"
                    value="Callout Initiated"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.CALLOUT_INIT' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="maintenance"
                    value="Maintenance"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.MAINTENANCE' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
          <p-divider />
          <div formGroupName="contactLocInfo" class="info-form">
            <div class="card-header header-spacing">
              <h3>{{ 'CRM.LABEL.FACILITY_CONACTS_LOC' | translate }}</h3>
            </div>
            <div class="contact-loc-info row">
              <div class="contact row-item contact-row-item">
                <label for="contact"
                  >{{ 'CRM.LABEL.CONTACT' | translate }}:
                </label>
                {{ controllerNote()?.contactName }}
              </div>
              @if (category() === 'System') {
                <div class="row-item">
                  <label class="system-name" for="systemName"
                    >{{ 'CRM.LABEL.SYSTEM' | translate }}:
                    <span class="required">*</span></label
                  >
                  {{ controllerNote()?.system }}
                </div>
              }
              @if (category() !== 'Pipeline' && category() !== 'System') {
                <div class="row-item facility-name-row-item">
                  @if (showActiveVisitors) {
                    <button
                      type="button"
                      pButton
                      icon="fa fa-users"
                      pTooltip="{{
                        'CRM.LABEL.SIGNED_IN_VISITORS' | translate
                      }}"
                      (click)="openMusterListDialog()"
                      class="visitors-btn"
                    ></button>
                  }
                  @if (showActiveFacilityNotes) {
                    <button
                      type="button"
                      pButton
                      icon="fa fa-commenting-o"
                      pTooltip="{{ 'CRM.LABEL.FACILITY_NOTES' | translate }}"
                      (click)="openFacilityNotesDialog()"
                      class="facility-notes-btn"
                    ></button>
                  }
                  <label for="facility"
                    >{{ 'COMMON.LABEL.FACILITY' | translate }}:
                    @if (category() !== 'External Caller') {
                      <span class="required">*</span>
                    }
                  </label>
                  {{ controllerNote()?.facilityName }}
                </div>
                <div class="facility-id-row-item row-item">
                  <label for="facilityId"
                    >{{ 'COMMON.LABEL.FACILITY_ID' | translate }}:
                    @if (category() !== 'External Caller') {
                      <span class="required">*</span>
                    }
                  </label>
                  {{ controllerNote()?.facilityUID }}
                </div>
                <div class="scada-id-row-item row-item">
                  <label for="scadaId"
                    >{{ 'COMMON.LABEL.SCADA_ID' | translate }}:</label
                  >
                  {{ controllerNote()?.facilityScadaId }}
                </div>
              }
            </div>
            <div class="contact-loc-info row">
              @if (category() === 'Valve') {
                <div class="valve-position row-item">
                  <label for="valvePosition"
                    >{{ 'CRM.LABEL.VALVE_POSITION' | translate }}:
                    <span class="required">*</span>
                  </label>
                  {{ controllerNote()?.valvePosition }}
                </div>
              }
            </div>
            @if (category() === 'External Caller') {
              <div class="break"></div>
              <div class="location-info row">
                <div class="state row-item">
                  <label for="state"
                    >{{ 'LOCATION.LABEL.STATE' | translate }}:</label
                  >
                  {{ controllerNote()?.state }}
                </div>
                <div class="county row-item">
                  <label for="county"
                    >{{ 'LOCATION.LABEL.COUNTY' | translate }}:
                  </label>
                  {{ controllerNote()?.county }}
                </div>
                <div class="township row-item">
                  <label for="township"
                    >{{ 'LOCATION.LABEL.TOWNSHIP' | translate }}:
                  </label>
                  {{ controllerNote()?.township }}
                </div>
              </div>
              <div class="break"></div>
              <div class="external-caller-info row">
                <div class="contact-phone row-item">
                  <label for="contactPhone"
                    >{{ 'CRM.LABEL.PHONE_NUMBER' | translate }}:
                  </label>
                  {{ controllerNote()?.phoneNumber }}
                </div>
                <div class="first-name row-item">
                  <label for="firstName"
                    >{{ 'CRM.LABEL.CALLER_FIRST' | translate }}:
                  </label>
                  {{ controllerNote()?.callerFirstName }}
                </div>
                <div class="last-name row-item">
                  <label for="lastName"
                    >{{ 'CRM.LABEL.CALLER_LAST' | translate }}:
                  </label>
                  {{ controllerNote()?.callerLastName }}
                </div>
              </div>
            }
            @if (
              category() === 'Pipeline' || category() === 'External Caller'
            ) {
              <div class="break"></div>
              <div class="pipeline-info row">
                <div class="pipe-num row-item">
                  <label for="pipelineNum"
                    >{{ 'CRM.LABEL.PIPELINE' | translate }}:
                    @if (category() !== 'External Caller') {
                      <span class="required">*</span>
                    }
                  </label>
                  {{ controllerNote()?.pipeline }}
                </div>
                <div class="pipe-section row-item">
                  <label for="pipelineSection"
                    >{{ 'CRM.LABEL.PIPELINE_SECTION' | translate }}:
                  </label>
                  {{ controllerNote()?.pipelineSection }}
                </div>
              </div>
            }
            @if (category() === 'Compressor Station') {
              <div class="compressor-station-info">
                <div class="row-item">
                  <label class="unit-label" for="unit"
                    >{{ 'CRM.LABEL.UNIT' | translate }}:
                  </label>
                  {{ controllerNote()?.unit }}
                </div>
                <div class="row-item">
                  <label class="unit-status-label" for="unitStatus"
                    >{{ 'CRM.LABEL.UNIT_STATUS' | translate }}:
                  </label>
                  {{ controllerNote()?.unitStatus?.name }}
                </div>
                <div class="row-item">
                  <label class="scada-ctrl-label" for="SCADAControl"
                    >{{ 'CRM.LABEL.SCADA_CONTROL' | translate }}:
                  </label>
                  {{ controllerNote()?.SCADAControl }}
                </div>
              </div>
            }
          </div>
        </form>
        <p-divider />
        <div>
          <div class="card-header entries-header">
            <h2>{{ 'CRM.LABEL.NOTE_ENTRIES' | translate }}</h2>
          </div>
          @for (entry of entries; track entry.id; let i = $index) {
            <div>
              @if (i !== 0) {
                <p-divider />
              }
              <app-log-entry [entry]="entry" #noteEntry />
            </div>
          } @empty {
            {{ 'CRM.MESSAGES.INFO.NO_ENTRIES' | translate }}
          }
          <app-progress-spinner [enabled]="entriesLoading" />
        </div>
      </div>
    } @else {
      <div class="center">
        <form [formGroup]="noteFormGroup" (ngSubmit)="onSubmit()">
          <div formGroupName="typeAOR">
            <div class="card-header">
              <h3>{{ 'CRM.LABEL.NOTE_TYPE_AOR' | translate }}</h3>
              @if (!isEditing) {
                <app-actions-dropdown
                  class="dropdown right-align"
                  [availableActions]="availableActions"
                  (actionSelected)="onActionSelected($event)"
                  #actions
                />
              }
            </div>
            <div class="note-type-aor">
              <div class="row">
                <div id="category" class="row-item">
                  <label for="category"
                    >{{ 'CRM.LABEL.CATEGORY' | translate }}:
                    <span class="required">*</span>
                  </label>
                  <p-select
                    class="input"
                    formControlName="category"
                    [options]="categories"
                    optionLabel="name"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.CATEGORY' | translate
                    }}"
                    (onChange)="onCategoryChange($event)"
                    appendTo="body"
                    scrollHeight="calc(100vh - 35vh)"
                  />
                </div>
                <div class="note-type" class="row-item">
                  <label for="noteType"
                    >{{ 'CRM.LABEL.NOTE_TYPE' | translate }}:
                    <span class="required">*</span></label
                  >
                  <p-select
                    class="input"
                    formControlName="noteType"
                    [options]="noteTypes"
                    optionLabel="name"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.NOTE_TYPE' | translate
                    }}"
                    appendTo="body"
                  />
                </div>
                <div id="createdAt" class="text-center" class="row-item">
                  <label for="createdAt"
                    >{{ 'COMMON.LABEL.CREATED_AT' | translate }}:
                    <span class="required">*</span>
                  </label>
                  <p-datepicker
                    class="input"
                    formControlName="createdAt"
                    [showTime]="true"
                    hourFormat="24"
                    appendTo="body"
                  />
                </div>
                <div id="aor" class="row-item">
                  <label for="aor"
                    >{{ 'CRM.LABEL.AOR' | translate }}:
                    <span class="required">*</span>
                  </label>
                  <p-select
                    class="input"
                    formControlName="aor"
                    [options]="totalAors()"
                    optionLabel="name"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.AOR' | translate
                    }}"
                    appendTo="body"
                    (onChange)="this.aorChanged()"
                  />
                </div>
              </div>
              <div class="break"></div>
              <div class="checkbox-row">
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="maop"
                    value="MAOP"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.MAOP' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="falseAlarm"
                    value="False Alarm"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.FALSE_ALARM' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="abnormalOperation"
                    value="Abnormal Operation"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.ABNORMAL_OP' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="includeInTurnover"
                    value="Include in Turnover"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.INC_IN_TURNOVER' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="calloutInitiated"
                    value="Callout Initiated"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.CALLOUT_INIT' | translate }}</label>
                </div>
                <div class="checkbox-option">
                  <p-checkbox
                    class="col-sm-2"
                    formControlName="maintenance"
                    value="Maintenance"
                    [binary]="true"
                  />
                  <label>{{ 'CRM.LABEL.MAINTENANCE' | translate }}</label>
                </div>
              </div>
            </div>
          </div>
          <p-divider />
          <div formGroupName="contactLocInfo" class="info-form">
            <div class="card-header header-spacing">
              <h3>{{ 'CRM.LABEL.FACILITY_CONTACTS_LOC' | translate }}</h3>
            </div>
            <div class="contact-loc-info row">
              <div class="contact row-item contact-row-item">
                <label for="contact"
                  >{{ 'CRM.LABEL.CONTACT' | translate }}:
                </label>
                <p-select
                  class="input"
                  formControlName="contact"
                  [options]="contacts"
                  optionLabel="dropdownName"
                  [filter]="true"
                  filterBy="dropdownName"
                  placeholder="{{
                    'CRM.MESSAGES.PLACEHOLDER.CONTACT' | translate
                  }}"
                  appendTo="body"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="30"
                  [showClear]="true"
                />
              </div>
              @if (category() === 'System') {
                <div class="system-name row-item">
                  <label for="systemName"
                    >{{ 'CRM.LABEL.SYSTEM' | translate }}:
                    <span class="required">*</span></label
                  >
                  <input
                    class="input"
                    pInputText
                    formControlName="systemName"
                  />
                </div>
              }
              @if (category() !== 'Pipeline' && category() !== 'System') {
                <div class="row-item facility-name-row-item">
                  @if (showActiveVisitors) {
                    <button
                      type="button"
                      pButton
                      icon="fa fa-users"
                      pTooltip="{{
                        'CRM.LABEL.SIGNED_IN_VISITORS' | translate
                      }}"
                      (click)="openMusterListDialog()"
                      class="visitors-btn"
                    ></button>
                  }
                  @if (showActiveFacilityNotes) {
                    <button
                      type="button"
                      pButton
                      icon="fa fa-commenting-o"
                      pTooltip="{{ 'CRM.LABEL.FACILITY_NOTES' | translate }}"
                      (click)="openFacilityNotesDialog()"
                      class="facility-notes-btn"
                    ></button>
                  }
                  <label for="facility"
                    >{{ 'COMMON.LABEL.FACILITY' | translate }}:
                    @if (category() !== 'External Caller') {
                      <span class="required">*</span>
                    }
                  </label>
                  @if (facilitiesLoading) {
                    <span class="input facility-loading-text">{{
                      controllerNote()?.facilityName ?? 'Loading facilities...'
                    }}</span>
                  } @else {
                    <p-select
                      class="input"
                      formControlName="facility"
                      placeholder="Select a Facility"
                      [options]="facilities"
                      optionLabel="facilityName"
                      [filter]="true"
                      filterBy="facilityName"
                      (onChange)="onFacilityChange($event)"
                      appendTo="body"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="30"
                      [showClear]="true"
                    />
                  }
                </div>
                <div class="facility-id-row-item row-item">
                  <label for="facilityId"
                    >{{ 'COMMON.LABEL.FACILITY_ID' | translate }}:
                    @if (category() !== 'External Caller') {
                      <span class="required">*</span>
                    }
                  </label>
                  @if (facilitiesLoading) {
                    <span class="input facility-loading-text">{{
                      controllerNote()?.facilityUID ?? 'Loading...'
                    }}</span>
                  } @else {
                    <p-select
                      class="input"
                      formControlName="facilityId"
                      placeholder="Select a Facility Id"
                      [options]="facilityIds"
                      optionLabel="facilityUid"
                      [filter]="true"
                      filterBy="facilityUid"
                      (onChange)="onFacilityIdChange($event)"
                      appendTo="body"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="30"
                      [showClear]="true"
                    />
                  }
                </div>
                <div class="scada-id-row-item row-item">
                  <label for="scadaId">SCADA ID:</label>
                  @if (facilitiesLoading) {
                    <span class="input facility-loading-text">{{
                      controllerNote()?.facilityScadaId ?? 'Loading...'
                    }}</span>
                  } @else {
                    <p-select
                      class="input"
                      formControlName="facilityScadaId"
                      placeholder="Select a Scada Id"
                      [options]="getScadaIdOptions()"
                      optionLabel="scadaId"
                      [filter]="true"
                      filterBy="scadaId"
                      (onChange)="onScadaIdChange($event)"
                      appendTo="body"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="30"
                      [showClear]="true"
                    />
                  }
                </div>
              }
            </div>
            <div class="contact-loc-info row">
              @if (category() === 'Valve') {
                <div class="valve-position row-item">
                  <label for="valvePosition"
                    >{{ 'CRM.LABEL.VALVE_POSITION' | translate }}:
                    <span class="required">*</span>
                  </label>
                  <p-select
                    class="input"
                    optionLabel="name"
                    [options]="valvePositions"
                    formControlName="valvePosition"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.VALVE_POSITION' | translate
                    }}"
                    appendTo="body"
                    [showClear]="true"
                  />
                </div>
              }
            </div>
            @if (category() === 'External Caller') {
              <div class="break"></div>
              <div class="location-info row">
                <div class="state row-item">
                  <label for="state"
                    >{{ 'LOCATION.LABEL.STATE' | translate }}:</label
                  >
                  <p-select
                    class="input"
                    formControlName="state"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.STATE' | translate
                    }}"
                    [options]="states"
                    optionLabel="name"
                    [filter]="true"
                    filterBy="name"
                    appendTo="body"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="30"
                    [showClear]="true"
                    (onChange)="filterLocations()"
                  />
                </div>
                <div class="county row-item">
                  <label for="county"
                    >{{ 'LOCATION.LABEL.COUNTY' | translate }}:
                  </label>
                  <p-select
                    class="input"
                    formControlName="county"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.COUNTY' | translate
                    }}"
                    [options]="counties"
                    optionLabel="name"
                    [filter]="true"
                    filterBy="name"
                    appendTo="body"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="30"
                    [showClear]="true"
                    (onChange)="filterLocations()"
                  />
                </div>
                <div class="township row-item">
                  <label for="township"
                    >{{ 'LOCATION.LABEL.TOWNSHIP' | translate }}:
                  </label>
                  <p-select
                    class="input"
                    formControlName="township"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.TOWNSHIP' | translate
                    }}"
                    [options]="townships"
                    optionLabel="name"
                    [filter]="true"
                    filterBy="name"
                    appendTo="body"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="30"
                    [showClear]="true"
                    (onChange)="filterLocations()"
                  />
                </div>
              </div>
              <div class="break"></div>
              <div class="external-caller-info row">
                <div class="contact-phone row-item">
                  <label for="contactPhone"
                    >{{ 'CRM.LABEL.PHONE_NUMBER' | translate }}:
                  </label>
                  <input
                    class="input"
                    pInputText
                    formControlName="contactPhone"
                  />
                </div>
                <div class="first-name row-item">
                  <label for="firstName"
                    >{{ 'CRM.LABEL.CALLER_FIRST' | translate }}:
                  </label>
                  <input
                    class="input"
                    pInputText
                    formControlName="callerFirstName"
                  />
                </div>
                <div class="last-name row-item">
                  <label for="lastName"
                    >{{ 'CRM.LABEL.CALLER_LAST' | translate }}:
                  </label>
                  <input
                    class="input"
                    pInputText
                    formControlName="callerLastName"
                  />
                </div>
              </div>
            }
            @if (
              category() === 'Pipeline' || category() === 'External Caller'
            ) {
              <div class="break"></div>
              <div class="pipeline-info row">
                <div class="pipe-num row-item">
                  <label for="pipelineNum"
                    >{{ 'CRM.LABEL.PIPELINE' | translate }}:
                    @if (category() !== 'External Caller') {
                      <span class="required">*</span>
                    }
                  </label>
                  <input
                    class="input"
                    pInputText
                    formControlName="pipelineNum"
                  />
                </div>
                <div class="pipe-section row-item">
                  <label for="pipelineSection"
                    >{{ 'CRM.LABEL.PIPELINE_SECTION' | translate }}:
                  </label>
                  <input
                    class="input"
                    pInputText
                    formControlName="pipelineSection"
                  />
                </div>
              </div>
            }
            @if (category() === 'Compressor Station') {
              <div class="compressor-station-info">
                <div class="row-item">
                  <label class="unit-label" for="unit"
                    >{{ 'CRM.LABEL.UNIT' | translate }}:
                  </label>
                  <input class="unit-input" pInputText formControlName="unit" />
                </div>
                <div class="row-item">
                  <label class="unit-status-label" for="unitStatus"
                    >{{ 'CRM.LABEL.UNIT_STATUS' | translate }}:
                  </label>
                  <p-select
                    class="unit-status-input"
                    optionLabel="name"
                    [options]="unitStatuses"
                    formControlName="unitStatus"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.UNIT_STATUS' | translate
                    }}"
                    appendTo="body"
                    [showClear]="true"
                  />
                </div>
                <div class="row-item">
                  <label class="scada-ctrl-label" for="SCADAControl"
                    >{{ 'CRM.LABEL.SCADA_CONTROL' | translate }}:
                  </label>
                  <p-select
                    class="scada-ctrl-input"
                    optionLabel="name"
                    optionValue="id"
                    [options]="SCADAControlValues()"
                    formControlName="SCADAControl"
                    placeholder="{{
                      'CRM.MESSAGES.PLACEHOLDER.SCADA_CONTROL' | translate
                    }}"
                    appendTo="body"
                    [showClear]="true"
                  />
                </div>
              </div>
            }
          </div>
          @if (formType() === 'Create') {
            <!-- Show initial note entry editor on create form -->
            <section class="initial-note">
              <label for="initialNoteEntry"
                >{{ 'CRM.LABEL.INITIAL_NOTE_ENTRY' | translate }}:</label
              >
              <p-editor
                [style]="{ height: '30vh' }"
                name="initialNoteEntry"
                formControlName="initialNoteEntry"
              />
            </section>
          }
          @if (isEditing) {
            <button
              pButton
              pRipple
              type="submit"
              label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
              class="p-button-raised p-button-success save-btn"
              [disabled]="!noteFormGroup.valid"
            ></button>
          }
        </form>
        @if (formType() === 'Edit') {
          <p-divider />
          <div>
            <div class="card-header entries-header">
              <h2>{{ 'CRM.LABEL.NOTE_ENTRIES' | translate }}</h2>
              @if (!isEditing) {
                <button
                  pButton
                  pRipple
                  type="button"
                  label="{{ 'CRM.LABEL.BUTTONS.ADD_ENTRY' | translate }}"
                  class="p-button-raised p-button-success right-align"
                  (click)="addEntry()"
                  [disabled]="!canAddEntries"
                ></button>
              }
            </div>
            @for (entry of entries; track entry.id; let i = $index) {
              <div>
                @if (i !== 0) {
                  <p-divider />
                }
                <app-log-entry
                  [entry]="entry"
                  [canEdit]="canEditEntry(entry)"
                  [canDelete]="canDeleteEntry(entry)"
                  (editEvent)="onEditEntry($event)"
                  (deleteEvent)="deleteEntry($event)"
                  #noteEntry
                />
              </div>
            } @empty {
              {{ 'CRM.MESSAGES.INFO.NO_ENTRIES' | translate }}
            }
            <app-progress-spinner [enabled]="entriesLoading" />
          </div>
        }
      </div>
    }
  }
</div>

<app-progress-spinner [enabled]="isLoading" />
<p-toast />

<div id="printContainer">
  <h3>{{ 'CRM.MESSAGES.HEADER.NOTE_INFORMATION' | translate }}</h3>
  <h4>{{ 'CRM.LABEL.NOTE_TYPE_AOR' | translate }}</h4>
  <ul>
    <li>
      {{ 'CRM.LABEL.NOTE_TYPE' | translate }}: {{ controllerNote()?.noteType }}
    </li>
    <li>
      {{ 'COMMON.LABEL.CREATED_AT' | translate }}:
      {{
        $safeNavigationMigration(controllerNote()?.createdAt)
          | date: 'MM/dd/yyyy HH:mm:ss'
      }}
      {{ timezone }}
    </li>
    <li>{{ 'CRM.LABEL.AOR' | translate }}: {{ controllerNote()?.AORName }}</li>
    <li>{{ 'CRM.LABEL.MAOP' | translate }}: {{ controllerNote()?.maop }}</li>
    <li>
      {{ 'CRM.LABEL.ABNORMAL_OP' | translate }}:
      {{ controllerNote()?.abnormalOperation }}
    </li>
    <li>
      {{ 'CRM.LABEL.FALSE_ALARM' | translate }}:
      {{ controllerNote()?.falseAlarm }}
    </li>
    <li>
      {{ 'CRM.LABEL.INC_IN_TURNOVER' | translate }}:
      {{ controllerNote()?.addToTurnover }}
    </li>
    <li>
      {{ 'CRM.LABEL.CALLOUT_INIT' | translate }}:
      {{ controllerNote()?.calloutInitiated }}
    </li>
    <li>
      {{ 'CRM.LABEL.MAINTENANCE' | translate }}:
      {{ controllerNote()?.maintenance }}
    </li>
  </ul>
  <h4>{{ 'CRM.LABEL.FACILITY_CONTACTS_LOC' | translate }}</h4>
  <ul>
    <li>
      {{ 'CRM.LABEL.CONTACT' | translate }}: {{ controllerNote()?.contactName }}
    </li>
    <li>
      {{ 'COMMON.LABEL.FACILITY' | translate }}:
      {{ controllerNote()?.facilityName }}
    </li>
    <li>
      {{ 'COMMON.LABEL.FACILITY_ID' | translate }}:
      {{ controllerNote()?.facilityUID }}
    </li>
    <li>
      {{ 'COMMON.LABEL.SCADA_ID' | translate }}:
      {{ controllerNote()?.facilityScadaId }}
    </li>
    <li>
      {{ 'LOCATION.LABEL.STATE' | translate }}: {{ controllerNote()?.state }}
    </li>
    <li>
      {{ 'LOCATION.LABEL.COUNTY' | translate }}: {{ controllerNote()?.county }}
    </li>
    <li>
      {{ 'LOCATION.LABEL.TOWNSHIP' | translate }}:
      {{ controllerNote()?.township }}
    </li>
    <li>
      {{ 'CRM.LABEL.CALLER_FIRST' | translate }}:
      {{ controllerNote()?.callerFirstName }}
    </li>
    <li>
      {{ 'CRM.LABEL.CALLER_LAST' | translate }}:
      {{ controllerNote()?.callerLastName }}
    </li>
    <li>
      {{ 'CRM.LABEL.PHONE_NUMBER' | translate }}:
      {{ controllerNote()?.phoneNumber }}
    </li>
    <li>
      {{ 'CRM.LABEL.PIPELINE' | translate }}: {{ controllerNote()?.pipeline }}
    </li>
    <li>
      {{ 'CRM.LABEL.PIPELINE_SECTION' | translate }}:
      {{ controllerNote()?.pipelineSection }}
    </li>
    <li>
      {{ 'CRM.LABEL.SYSTEM' | translate }}: {{ controllerNote()?.system }}
    </li>
    <li>{{ 'CRM.LABEL.UNIT' | translate }}: {{ controllerNote()?.unit }}</li>
    <li>
      {{ 'CRM.LABEL.UNIT_STATUS' | translate }}:
      {{ controllerNote()?.unitStatus?.name }}
    </li>
    <li>
      {{ 'CRM.LABEL.SCADA_CONTROL' | translate }}:
      {{ controllerNote()?.SCADAControl?.name }}
    </li>
    <li>
      {{ 'CRM.LABEL.VALVE_POSITION' | translate }}:
      {{ controllerNote()?.valvePosition?.name }}
    </li>
  </ul>
  @if (entries && entries.length > 0) {
    <h4>{{ 'CRM.LABEL.NOTE_ENTRIES' | translate }}</h4>
  }
  @for (entry of entries; track entry.id; let i = $index) {
    <div>
      <p>{{ 'COMMON.LABEL.ENTRY' | translate }} {{ i + 1 }}</p>
      <ul>
        <li>
          {{ 'COMMON.LABEL.TIME' | translate }}:
          {{ entry.time | date: 'MM/dd/yyyy HH:mm:ss' }} {{ timezone }}
        </li>
        <li>
          {{ 'COMMON.LABEL.CREATED_BY' | translate }}: {{ entry.createdBy }}
        </li>
        <li>
          {{ 'COMMON.LABEL.NOTE' | translate }}:
          <span class="break-words" [innerHTML]="entry.note"></span>
        </li>
      </ul>
    </div>
  }
</div>
